var map = {
	"./NAPGN_horizontalalternate_EN_colour.png": "./src/img/NAPGN_horizontalalternate_EN_colour.png",
	"./NAPGN_horizontalalternate_EN_white.png": "./src/img/NAPGN_horizontalalternate_EN_white.png",
	"./about-stats/noun_World_Map_1339294_000000.svg": "./src/img/about-stats/noun_World_Map_1339294_000000.svg",
	"./about-stats/noun_report_1326908_000000.svg": "./src/img/about-stats/noun_report_1326908_000000.svg",
	"./about-stats/peer-learning-events.svg": "./src/img/about-stats/peer-learning-events.svg",
	"./about-stats/technical-support.svg": "./src/img/about-stats/technical-support.svg",
	"./analysis-communications.png": "./src/img/analysis-communications.png",
	"./banner-mask.png": "./src/img/banner-mask.png",
	"./favicon/apple-touch-icon-114x114.png": "./src/img/favicon/apple-touch-icon-114x114.png",
	"./favicon/apple-touch-icon-120x120.png": "./src/img/favicon/apple-touch-icon-120x120.png",
	"./favicon/apple-touch-icon-144x144.png": "./src/img/favicon/apple-touch-icon-144x144.png",
	"./favicon/apple-touch-icon-152x152.png": "./src/img/favicon/apple-touch-icon-152x152.png",
	"./favicon/apple-touch-icon-57x57.png": "./src/img/favicon/apple-touch-icon-57x57.png",
	"./favicon/apple-touch-icon-60x60.png": "./src/img/favicon/apple-touch-icon-60x60.png",
	"./favicon/apple-touch-icon-72x72.png": "./src/img/favicon/apple-touch-icon-72x72.png",
	"./favicon/apple-touch-icon-76x76.png": "./src/img/favicon/apple-touch-icon-76x76.png",
	"./favicon/favicon-128.png": "./src/img/favicon/favicon-128.png",
	"./favicon/favicon-16x16.png": "./src/img/favicon/favicon-16x16.png",
	"./favicon/favicon-196x196.png": "./src/img/favicon/favicon-196x196.png",
	"./favicon/favicon-32x32.png": "./src/img/favicon/favicon-32x32.png",
	"./favicon/favicon-96x96.png": "./src/img/favicon/favicon-96x96.png",
	"./favicon/mstile-144x144.png": "./src/img/favicon/mstile-144x144.png",
	"./favicon/mstile-150x150.png": "./src/img/favicon/mstile-150x150.png",
	"./favicon/mstile-310x150.png": "./src/img/favicon/mstile-310x150.png",
	"./favicon/mstile-310x310.png": "./src/img/favicon/mstile-310x310.png",
	"./favicon/mstile-70x70.png": "./src/img/favicon/mstile-70x70.png",
	"./graphpaper.png": "./src/img/graphpaper.png",
	"./icon/alignment.png": "./src/img/icon/alignment.png",
	"./icon/financing_nap_process.png": "./src/img/icon/financing_nap_process.png",
	"./icon/gender.png": "./src/img/icon/gender.png",
	"./icon/monitoring_and_evaluation.png": "./src/img/icon/monitoring_and_evaluation.png",
	"./icon/sector_integration.png": "./src/img/icon/sector_integration.png",
	"./icon/strategic_communications.png": "./src/img/icon/strategic_communications.png",
	"./icon/vertical_integration.png": "./src/img/icon/vertical_integration.png",
	"./innovative-financing/DEgov-BMZ-Logo_en.svg.png": "./src/img/innovative-financing/DEgov-BMZ-Logo_en.svg.png",
	"./innovative-financing/idrc-logo-full-name-wordmark.png": "./src/img/innovative-financing/idrc-logo-full-name-wordmark.png",
	"./innovative-financing/iisd-logo.png": "./src/img/innovative-financing/iisd-logo.png",
	"./logo/BMZ_en.png": "./src/img/logo/BMZ_en.png",
	"./logo/BMZ_en_gray.png": "./src/img/logo/BMZ_en_gray.png",
	"./logo/iisd-acronym-logo.png": "./src/img/logo/iisd-acronym-logo.png",
	"./nap-logo-2022.png": "./src/img/nap-logo-2022.png",
	"./napgn-iso-mark.svg": "./src/img/napgn-iso-mark.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive \\.(png%7Cjpe?g%7Csvg)$";